import { configureStore } from '@reduxjs/toolkit';
import {  tableDataReducer, UnchangedTableDataReducer, distinctDataThroughSingleApiReducer,regionDataReducer, GPUReducer } from './reducers/rootReducer'; 

const store = configureStore({
  reducer: {
    tableData: tableDataReducer.reducer,
        distinctDataThroughSingleApi: distinctDataThroughSingleApiReducer.reducer,
    GPUData: GPUReducer.reducer,
    managedTableData: UnchangedTableDataReducer.reducer,
    regionData:regionDataReducer.reducer
  }
});

export default store;

